import * as Sentry from "@sentry/react";
import { ReleaseAutoReload, useIsReloadDirty } from "@simplicity/ui";
import { useCallback } from "react";

/**
 * Web-admin mount for the release auto-reload (SIM-1670 Slice 2d). Same idle/hidden reload as the
 * portal, gated on dirty-form state so a config form with unsaved edits is never reloaded out from
 * under the user. No mutation gate here: web-admin has no root React Query provider, and a form
 * stays `isDirty` until a successful save, covering the in-flight-save window.
 */
export function ReleaseWatcher() {
  const reloadBlocked = useIsReloadDirty();

  const onBeforeReload = useCallback((info: { from: string; to: string }) => {
    Sentry.addBreadcrumb({
      category: "release",
      message: "auto-reload",
      level: "info",
      data: info,
    });
  }, []);

  return <ReleaseAutoReload reloadBlocked={reloadBlocked} onBeforeReload={onBeforeReload} />;
}
